<div class="databox">{{ databoxProgressionNumericRepository.output$ | async }}</div>
